import { AnimationButton } from "../../Animation";

const SubMenu = () => {
  return (
    <div
      className="framer-s59e38 !hidden lg:!flex"
      data-framer-name="Get this template"
    >
      <div className="framer-1u65l8y" data-framer-name="Filler" />
      <AnimationButton>
        <div className="framer-1g2rjbk-container">
          <a
            className="framer-hhOXC framer-1qihf93 framer-v-1qihf93 framer-9ti88g bg-[var(--token-dfd29766-9b54-40dd-9398-e62b74c1aefb,rgb(34,34,34))] rounded-[8px]"
            data-framer-name="Button State 1"
            data-highlight="true"
            href="https://build.codeblaze.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              className="framer-11purux bg-gradient-radial from-[#70befa] to-transparent rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-lg"
              data-framer-name="Stroke"
            />
            <div
              className="framer-1qkh0sq bg-[#161616] rounded-tl-md rounded-tr-md rounded-bl-md rounded-br-md"
              data-framer-name="Fill"
            />
            <div
              className="framer-1mkf86x outline-none flex flex-col justify-start flex-shrink-0 text-white link text-blue-500 underline"
              data-framer-component-type="RichTextContainer"
            >
              <a href="https://build.codeblaze.ai" target="_blank">

                <h4 className="framer-text font-[Switzer, sans-serif] text-white tracking-normal">
                  <span
                    data-text-fill="true"
                    className="framer-text text-[14px] bg-gradient-to-r from-white to-[#70befa]"
                  >
                    Sign In
                  </span>
                </h4>
              </a>
            </div>
          </a>
        </div>
      </AnimationButton>
    </div>
  );
};

export default SubMenu;
